// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import axios from 'axios'
import QS from 'qs'
import serverPath from './assets/js/serverPath.js'
import $ from 'jquery'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/css/swiper.css'
import 'lib-flexible'
import './utils/flexible.js'
import countTo from 'vue-count-to'
import settings from './assets/js/settings.js'
import request from './assets/js/request.js'
	import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.settings = settings
Vue.prototype.request = request
Vue.prototype.$http = axios

// 设置全局请求前缀
axios.defaults.baseURL = 'http://' + serverPath.serverPath
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js